import { useState } from "react";
import { Pagination } from "../../../components";
import { dateToHumanFormat, roundNum } from "../../../utils/constants";
import { HugeiconsIcon } from '@hugeicons/react';
import { Message01Icon } from '@hugeicons/core-free-icons';

function Transactions({ loan }) {

    const transactions = loan?.ledgerRows;

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = transactions?.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(transactions?.length / recordsPerPage);

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
            <div className="overflow-x-auto">
                <table className="min-w-full">
                    <thead>
                        <tr className="border-b border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60">
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Transaction ID</th>
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Payment Date</th>
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Capital (GHS)</th>
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Interest (GHS)</th>
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Principal (GHS)</th>
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Amount (GHS)</th>
                            <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide">Balance</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                        {currentRecords && currentRecords.length > 0 ? (
                            currentRecords.map((item, index) => (
                                <tr key={index} className="hover:bg-gray-50/50 dark:hover:bg-gray-700/30 transition-colors text-sm text-gray-700 dark:text-gray-300">
                                    <td className="px-5 py-3.5 align-top">
                                        <span className="font-mono text-xs text-gray-500 dark:text-gray-400">{item?.transactionId}</span>
                                        {item?.remarks && (
                                            <span className="mt-1 flex items-start gap-1 text-[11px] text-gray-400 dark:text-gray-500 max-w-[220px]" title={item.remarks}>
                                                <HugeiconsIcon icon={Message01Icon} size={12} className="mt-0.5 shrink-0" />
                                                <span className="line-clamp-2">{item.remarks}</span>
                                            </span>
                                        )}
                                    </td>
                                    <td className="px-5 py-3.5 align-top">{dateToHumanFormat(item?.date)}</td>
                                    <td className="px-5 py-3.5 align-top">{item?.capital}</td>
                                    <td className="px-5 py-3.5 align-top">{item?.interest}</td>
                                    <td className="px-5 py-3.5 align-top">{item?.principal}</td>
                                    <td className="px-5 py-3.5 font-medium align-top">{item?.payment && roundNum(item?.payment, 2)}</td>
                                    <td className="px-5 py-3.5 align-top">{item?.balance}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={7} className="px-5 py-10 text-center text-sm text-gray-400">
                                    No payments made.
                                </td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="border-t border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60 font-semibold text-sm text-gray-800 dark:text-gray-100">
                            <td className="px-5 py-3.5" colSpan={3}>Total</td>
                            <td className="px-5 py-3.5">{loan?.totalInterest}</td>
                            <td className="px-5 py-3.5">{loan?.totalPrincipal}</td>
                            <td className="px-5 py-3.5">{loan?.totalPaid && `GHS ${roundNum(loan?.totalPaid, 2)}`}</td>
                            <td className="px-5 py-3.5"></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            {currentRecords && (
                <Pagination
                    nPages={nPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    length={transactions?.length}
                />
            )}
        </div>
    );
}

export default Transactions;
